<template>
  <div class="contact-us">
    <page-name v-bind:image="require('@/assets/img/contact-us.png')"  v-bind:name="$t('i18n.Website.ContractUs')"></page-name>

    <b-container class="contact-form">
      <b-row>
        <b-col>
          <div class="text-value">
            {{ $t('i18n.Website.Name') }}
            <span class="red">*</span>
          </div>
          <b-form-input class="text-input"
          v-model="$v.contactRequest.name.$model"
          :state="$v.contactRequest.name.$dirty ? !$v.contactRequest.name.$error : null"
          trim></b-form-input>

          <div class="text-value">
            {{ $t('i18n.Website.Email') }}
            <span class="red">*</span>
          </div>
          <b-form-input class="text-input"
          v-model="$v.contactRequest.email.$model"
          :state="$v.contactRequest.email.$dirty ? !$v.contactRequest.email.$error : null"
          trim></b-form-input>

          <div class="text-value">{{ $t('i18n.Website.Phone') }}</div>
          <b-form-input class="text-input" v-model="contactRequest.phone" trim></b-form-input>

          <div class="text-value">{{ $t('i18n.Website.Company') }}</div>
          <b-form-input class="text-input" v-model="contactRequest.company" trim></b-form-input>
        </b-col>

        <b-col>
          <div class="text-value">
            {{ $t('i18n.Website.Message') }}
            <span class="red">*</span>
          </div>
          <b-form-textarea id="input-1" class="message-input"
          v-model="$v.contactRequest.content.$model"
          :state="$v.contactRequest.content.$dirty ? !$v.contactRequest.content.$error : null"
           trim></b-form-textarea>
          <div class="d-flex flex-wrap sub-send-line">
            <img
              src="@/assets/img/subscribe.png"
              class="subscribe-icon"
              v-if="contactRequest.subscribe"
              v-on:click="contactRequest.subscribe = !contactRequest.subscribe"
            />
            <img
              src="@/assets/img/unsubscribe.png"
              class="subscribe-icon"
              v-else
              v-on:click="contactRequest.subscribe = !contactRequest.subscribe"
            />
            <div class="text-value">{{ $t('i18n.Website.Subscribe') }}</div>
            <b-button variant="primary send-btn" v-on:click="Send()">{{ $t('i18n.Website.SendMessage') }}</b-button>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import PageName from '@/components/PageName'
import request from '../../util/request'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import MessageBox from '@/components/MessageBox'

export default {
  name: 'ContactUS',
  mixins: [validationMixin],
  components: {
    PageName,
    MessageBox
  },
  data () {
    return {
      contactRequest: {
        name: '',
        email: '',
        phone: '',
        company: '',
        content: '',
        subscribe: false
      }
    }
  },
  validations: {
    contactRequest: {
      name: {
        required
      },
      email: {
        required,
        email
      },
      content: {
        required
      }
    }
  },
  methods: {
    Send () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      this.$bvModal.msgBoxOk('Message successfully sent. We will respond to your message ASAP.', {
        title: 'Tips',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true,
        id: 'send-success'
      })

      request.post('/supportRequest', this.contactRequest).then()
        .catch(() => {
          this.$bvModal.hide('send-success')
          this.$bvModal.msgBoxOk('Network Error, message send failed. Please try again', {
            title: 'Error',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'success',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true
          })
        })

      this.contactRequest = {
        name: '',
        email: '',
        phone: '',
        company: '',
        content: '',
        subscribe: false
      }

      this.$v.$reset()
    }
  }
}
</script>

<style lang="scss">
@import url("../../assets/css/text.scss");
.contact-us {
  width: 100%;
  margin: 0 auto;
  padding-top: 80px;

  .subscribe-icon {
    height: 20px;
    width: 20px;
    cursor: pointer;
    margin-right: 10px;
  }
}

@media (min-width: 1000px) {
  .contact-us {
    width: 1000px;
  }
}

.text-input {
  width: 259px !important;
  height: 28px !important;
  background: #f9fdff !important;
  border-radius: 0 !important;
  margin: 10px 0 !important;
}

.message-input {
  width: 600px !important;
  height: 172px !important;
  background: #f9fdff !important;
  max-width: 100% !important;
  resize: none !important;
  border-radius: 0 !important;
  margin: 10px 0 !important;
}

.red {
  color: red;
}

.sub-send-line {
  align-items: flex-end;
  margin-top: 30px;
  margin-left: 0px;
}

.send-btn {
  width: 200px;
  height: 32px;
  font-size: 16px;
  padding: 0px !important;
  margin-left: auto;
  margin-right: 15px;
  border: none !important;
}

.contact-form {
  margin-top: 40px;
  padding-left: 50px;
  margin-bottom: 80px;
}

@media (max-width: 500px) {
  .text-input {
    width: calc(100% - 40px) !important;
  }

  .col {
    flex-basis: auto !important;
  }

  .contact-form {
    padding: 20px;
  }

  .message-input {
    width: calc(100% - 40px) !important;
  }

  .send-btn {
    margin-top: 8px;
    margin-right: 35px;
  }
}
</style>



// WEBPACK FOOTER //
// src/Layout/components/contact-us.vue